import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetMe } from 'helpers/api_helper';
import { Action, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'slices';
import { profileFailed } from './reducer';

interface User {
  username: string;
  idx: number;
}

export const editProfile =
  (user: User): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      // let response: any = await postFakeProfile(user);
      // if (response) {
      //   dispatch(profileSuccess(response));
      // }
    } catch (error) {
      dispatch(profileFailed(error));
    }
  };

export const getMe = createAsyncThunk('auth/getMe', async () => {
  try {
    const response = callGetMe();
    return response;
  } catch (error) {
    return error;
  }
});
